import { Component, OnInit } from '@angular/core';
import { PermitTypeService } from 'app/services/permit-type.service';
import { AlertComponent } from 'app/popup/alert.component';
import { FormControl, Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';
import { CarrierTypeService } from 'app/services/carrier-type.service';
import { CountryService } from 'app/services/country.service';
import { PlaceService } from 'app/services/place.service';

@Component({
  selector: 'app-add-new-place',
  templateUrl: './add-new-place.component.html',
  styleUrls: ['./add-new-place.component.css']
})
export class AddNewPlaceComponent implements OnInit {
  form: UntypedFormGroup;
  pStatus: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;
  isCodeDup = false;
  isIdDup = false;
  selectedDisplay = 3;
  selectedSUI = 3;
  message = null;
  public isLoading = false;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  countryList: any = [];
  provinceList: any = [];
  placeList: any = [];
  selectedList: any;
  placeId: any = "";
  editFlag: boolean = false;
  constructor(private statusService: StatusService, private authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute, private countryService: CountryService,
    private carrierTypeService: CarrierTypeService, private formBuilder: UntypedFormBuilder,
     public utility: UtilityServiceService, private toastr: ToastrService,
    private placeService: PlaceService) {
    this.form = this.formBuilder.group({
      code: [''],
      name: [''],
      country_id: [''],
      border_country1_id: ['0'],
      border_country2_id: ['0'],
      province_id: [''],
      parent_place_id: [''],
      longitude: [''],
      latitude: [''],
      coordinates: [''],
      is_town: [true],
      is_border_post: [true],
      is_taxi_rank: [true],
      is_terminus: [true],
      type: [''],
      sort_order: [''],
      group_code: [''],
      display_ind: [''],
      is_active: [true],
      date_created: [new Date()],
      date_modified: [new Date()]

    });
  }


  ngOnInit() {
    this.isEdit = false;
    this.lblHeading = 'New Place';
    this.btnActionLabel = 'Save';
    let id: any = this.route.params['_value'].id;
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    id = atob(id);
    this.getCountries();
    this.getPlaces(id);
    this.getProvinces();
    this.placeId = btoa(id);
    this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName);
    if (this.router.url.includes('edit')) {
      let placeId: any = this.route.params['_value'].placeId;
      placeId = atob(placeId);
      //this.placeId=placeId;
      this.getSelectedPlace(placeId);
      this.editFlag = true;
    }
  }
  getCountries() {
    this.countryService.listAllCountries().subscribe(res => {
      this.countryList = res;
    })
  }
  getProvinces() {
    this.countryService.listAllProvinces().subscribe(res => {
      this.provinceList = res;
    })
  }
  getPlaces(id) {
    this.placeService.getAllCountryPlaces(id).subscribe(res => {
      this.placeList = res;
    })
  }
  savePlace() {
    let body: any = this.form.value;
    if (!body.is_border_post) {
      body.border_country1_id = null;
      body.border_country2_id = null;
    }
    if (this.editFlag) {
      body.id = this.selectedList.id;
      this.placeService.updatePlace(body).subscribe(res => {
        this.toastr.success('Place updated successfully');
        this.router.navigate(['/countries/list/' + this.placeId]);
      })
    } else {
      this.placeService.savePlace(body).subscribe(res => {
        this.toastr.success('New Place added successfully');
        this.router.navigate(['/countries/list/' + this.placeId]);
      })
    }

  }
  getSelectedPlace(id) {
    this.placeService.getPlaceById(id).subscribe(res => {
      this.selectedList = res;
      this.mergeData(res);
      this.lblHeading = this.selectedList.name;
    })
  }
  borderPostChange(isBorderCrossingRef) {
    let form = this.form.value;
    form.border_country1_id = null;
    form.border_country2_id = null;
    form.is_border_post = isBorderCrossingRef.checked;
    this.mergeData(form);
  }
  mergeData(list) {
    this.form.get('code').setValue(list.code);
    this.form.get('country_id').setValue(list.country_id);
    this.form.get('border_country1_id').setValue(list.border_country1_id == null ? 0 : list.border_country1_id);
    this.form.get('border_country2_id').setValue(list.border_country2_id == null ? 0 : list.border_country2_id);
    this.form.get('name').setValue(list.name);
    this.form.get('province_id').setValue(list.province_id);
    this.form.get('type').setValue(list.type);
    this.form.get('parent_place_id').setValue(list.parent_place_id);
    this.form.get('longitude').setValue(list.longitude);
    this.form.get('latitude').setValue(list.latitude);
    this.form.get('coordinates').setValue(list.coordinates);
    this.form.get('is_town').setValue(list.is_town);
    this.form.get('is_border_post').setValue(list.is_border_post);
    this.form.get('is_terminus').setValue(list.is_terminus);
    this.form.get('is_taxi_rank').setValue(list.is_taxi_rank);
    this.form.get('is_active').setValue(list.is_active);
    this.form.get('sort_order').setValue(list.sort_order);
    this.form.get('group_code').setValue(list.group_code);
    this.form.get('display_ind').setValue(list.display_ind);
    this.form.get('date_created').setValue(list.date_created);
    this.form.get('date_modified').setValue(list.date_modified);
    this.audit = this.utility.setAuditAttributes(list.date_created, this.user.LastName, list.date_modified, this.user.LastName);
  }

}
